import { useSelector } from "react-redux";
import { Message } from "../../../@types/message";
import { MessageItem } from "../../../components/Message/MessageItem";
import { selectDocumentHistory } from "../../../store/documentSupervisorShow/selectors/selectDocumentHIstory";

export const DocumentHistory: React.FC = () => {
  const history = useSelector(selectDocumentHistory);

  return (
    <section style={{ maxWidth: "900px" }}>
      {history.length > 0 ? (
        history.map((message: Message, index: number) => (
          <MessageItem message={message} key={index} routerLink="" />
        ))
      ) : (
        <p className="ion-text-center" style={{ fontWeight: 300 }}>
          No se han encontrado resultados
        </p>
      )}
    </section>
  );
};
